module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFDSURBVDiNrZTBccIwEEXfSsbJkRIowXQAZ4aBVMC4BCpiqCBhPJxxB3EJLoFjsGVvDg4O2IJhQv5tJe3fr6/VCh4koV0aWIBEQNSsao6S1irbuXNpN0cug/dXRmFtDyAjX4E2SUlP1sVvX+Q9ov1gEIEeEIb3SFooR5DprCwzAHNWcpNENVaVdV8WQ9BDk/tD9FIFm3tKhPp4Y2PYWAEmCYKJCpOHruNnGyWhXRojuvo7SQMDC8NTalpVkezDQM+hqqy7fhS2SgHCyvYLimwuVF2s3zLVA8VcPY7sw+Dzt3t9GRp3q3sO5QY0e1TFHXmpqWH3LE+tsjXzovoAzR8474Uo6dy51AAUppo2f6ePrqmdzePJuph//7QAs7LMCuvGovRmjYclL6wbn0nozqMzkiCYGNFV0/XtbMpAsxp2ja/X+Aa1VICpBEeaRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add-child-icon.png
// module id = iJT2
// module chunks = 1